import { useEffect, useState, useMemo } from 'react'
import { CircularProgressModal, ConfirmPopupModal } from '@!/components/Modal'
import { PrimaryButton } from '@!/components/Button'
import { getEndDate } from '@!/User/Bookshelf/util/Check'
import { useReadBook, useAppCookies } from '@!/Hooks'

export const ReadBookButton = ({ content }) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState(false)
  const [popupText, setPopupText] = useState('')

  const endDate = useMemo(() => getEndDate(content), [content])

  const [readContentMutation, redirectUrl, apiError, setApiError] = useReadBook('purchased')

  useEffect(() => {
    if (!redirectUrl) return

    window.location.href = redirectUrl
  }, [redirectUrl])

  const execReadBook = async () => {
    setConfirmModalOpen(false)
    readContentMutation.mutate({ contentId: content.content_id })
  }

  const handleReadBook = (event) => {
    event.preventDefault()

    if (endDate) {
      const title = `「${content.content_name}」は${endDate}まで閲覧できます。`
      setPopupText(title)
      setConfirmModalOpen(true)
    } else {
      execReadBook()
    }
  }

  const handleApiError = () => {
    console.log(apiError)
    setApiError(null)
  }

  const { openViewerCookie, removeOpenViewerCookie } = useAppCookies()

  useEffect(() => {
    if (openViewerCookie === 'purchased') {
      removeOpenViewerCookie()
      // 即時ビューワー起動で詳細画面の履歴がスキップされるのを防ぐため、pushStateで履歴を念のため追加
      window.history.pushState(null, '', `/store/books/${content.content_id}`)
      execReadBook()
    }
  }, [openViewerCookie])

  return (
    <>
      <PrimaryButton width="100%" height="37px" onClick={(event) => handleReadBook(event)}>
        作品を読む
      </PrimaryButton>
      <ConfirmPopupModal handlePopup={() => execReadBook()} text={popupText} isOpen={confirmModalOpen} />
      <ConfirmPopupModal text="エラーが発生しました。" handlePopup={() => handleApiError()} isOpen={!!apiError} />
      <CircularProgressModal isOpen={readContentMutation.isPending} />
    </>
  )
}
